import http from 'plugins/axios'

export default {
  getUserList({
    page = 1,
    size = 25,
    queryType,
    queryValue,
    realName,
    userStatus,
    userType,
    vipLevel,
    mark,
    showContactPlain,
  }) {
    return http.get({
      url: `/ta/admin/tenant/trade/user/${page}/${size}`,
      data: {
        queryType,
        queryValue,
        realName,
        userStatus,
        userType,
        vipLevel,
        mark,
        showContactPlain,
      },
    })
  },
  getVipUserEnums() {
    return http.get({
      url: '/ta/admin/tenant/vip/user/enums',
    })
  },
  updateVolunteer({ id, status }) {
    return http.post({
      url: `/ta/admin/tenant/trade/user/updateStatus/${id}`,
      data: {
        userVolunteerStatus: status,
      },
      dataType: 'form',
    })
  },
  updateBlocking({ id, status, content }) {
    return http.post({
      url: '/ta/admin/tenant/trade/user/updateUserStatus',
      data: {
        id,
        userStatus: status,
        content: content,
      },
      dataType: 'form',
    })
  },
  cancelGoogle(data) {
    return http.post({
      url: '/ta/admin/tenant/user/delete/googleAuth',
      data,
      dataType: 'form',
    })
  },
  coutryCode() {
    return http.get({
      url: '/ta/admin/tenant/countryCodeList',
    })
  },
  updatInfo(data) {
    return http.post({
      url: '/ta/admin/tenant/user/update/tel',
      data,
      dataType: 'form',
    })
  },
  updateUserType(data) {
    return http.post({
      url: '/ta/admin/tenant/user/userType/update',
      data,
      dataType: 'form',
    })
  },
  updateDividendStatus(data) {
    return http.post({
      url: '/ta/admin/tenant/user/dividend/status/update',
      data,
      dataType: 'form',
    })
  },
  setNode(data) {
    return http.post({
      url: '/ta/admin/tenant/starplan/create/node',
      data,
      dataType: 'form',
    })
  },
  resetPassword(data) {
    return http.post({
      url: '/ta/admin/tenant/user/password/reset',
      data,
      dataType: 'form',
    })
  },
  mark(data) {
    return http.post({
      url: '/ta/admin/tenant/user/mark',
      data,
      dataType: 'form',
    })
  },
  addUser({ email, pwd }) {
    return http.post({
      url: `/ta/admin/tenant/trade/user/save?&email=${email}&pwd=${pwd}`,
    })
  },

  telOrEmail(data) {
    return http.get({
      url: `/ta/admin/user/telOrEmail`,
      data,
    })
  },
  getUserContactGoogleAuthSession() {
    return http.get({
      url: '/ta/admin/tenant/user/contact/google_auth_session',
    })
  },
  verifyUserContactGoogleAuth(data) {
    return http.post({
      url: '/ta/admin/tenant/user/contact/verify_google_auth',
      data,
      dataType: 'form',
    })
  },
  allowTrade(data) {
    return http.post({
      url: '/ta/admin/tenant/user/allowTrade',
      data,
      dataType: 'form',
    })
  },
  allowOpenPosition(data) {
    return http.post({
      url: '/ta/admin/tenant/user/allowOpenPosition',
      data,
      dataType: 'form',
    })
  },
  allowClosePosition(data) {
    return http.post({
      url: '/ta/admin/tenant/user/allowClosePosition',
      data,
      dataType: 'form',
    })
  },

  spotTrade(data) {
    return http.post({
      url: '/ta/admin/tenant/user/spotTrade',
      data,
      dataType: 'form',
    })
  },
  getSymbolList() {
    return http.get({
      url: '/ta/admin/channel/common/symbolList?type=CONTRACT',
    })
  },

  updateCfd(data) {
    return http.post({
      url: `/ta/admin/tenant/user/cfd`,
      data,
      dataType: 'form',
    })
  },

  artificialKyc(data) {
    return http.post({
      url: `/ta/admin/user/artificialKyc`,
      data,
      dataType: 'form',
    })
  },
  //用户折扣
  fetchDiscountRate({ userId, discountRate }) {
    return http.post({
      url: `/ta/admin/user/update/discountRate?&userId=${userId}&discountRate=${discountRate}`,
    })
  },
  updateCanLogin({ userId, canLogin }) {
    return http.post({
      url: `/ta/admin//tenant/user/canLoginPartner`,
      data: {
        userId,
        canLogin,
      },
      dataType: 'form',
    })
  },
  rebateRiskSwitch({ userId, rebateFlag }) {
    return http.post({
      url: '/ta/admin/tenant/user/rebateRiskSwitch',
      data: {
        userId,
        rebateFlag,
      },
      dataType: 'form',
    })
  },
  updateTenantAdminRemark({ userId, remark }) {
    return http.post({
      url: '/ta/admin/tenant/user/remark',
      data: {
        userId,
        remark,
      },
      dataType: 'form',
    })
  },
}
